// @ts-nocheck
import {create} from "zustand";

// CDN base URL for auth modal images
const AUTH_MODAL_IMAGES_CDN = "https://images.cdn.raspaygana.com.ve/images";

export const useAppConfig = create(set => ({
  bankName: "Banco Plaza",
  RIF: null,
  PagoMovilNumber: null,
  bannersCarousel: [],
  homeBodyBanners: [],
  webBanners: [],
  tabsConfig: [],
  // Auth modal images configuration
  authModalImages: {
    loginDesktopImage: null,
    loginMobileImage: null,
    registrationDesktopImage: null,
    registrationMobileImage: null,
  },
  setTabsConfig: tabsConfig => {
    set({
      tabsConfig,
    });
  },

  setPMInfo: (bankName, RIF, PagoMovilNumber) => {
    set({
      bankName,
      RIF,
      PagoMovilNumber,
    });
  },
  setBannersCarousel: banners => {
    // Filter the banners based on active and section
    const activePromoBanners = banners.filter(banner => banner.active && banner.section === "PromoBanners");
    const activeBodyBanners = banners.filter(banner => banner.active && banner.section === "BodyBanner");
    const activeWebBanners = banners.filter(banner => banner.active && banner.section === "WebPromoBanners");
    set({
      bannersCarousel: activePromoBanners,
      homeBodyBanners: activeBodyBanners,
      webBanners: activeWebBanners,
    });
  },
  setAuthModalImages: authModalImagesData => {
    // Build full URLs from the image keys
    const buildImageUrl = key => (key ? `${AUTH_MODAL_IMAGES_CDN}/${key}` : null);

    set({
      authModalImages: {
        loginDesktopImage: buildImageUrl(authModalImagesData?.login_desktop_image_key),
        loginMobileImage: buildImageUrl(authModalImagesData?.login_mobile_image_key),
        registrationDesktopImage: buildImageUrl(authModalImagesData?.registration_desktop_image_key),
        registrationMobileImage: buildImageUrl(authModalImagesData?.registration_mobile_image_key),
      },
    });
  },
}));
